import { Component, Input, OnInit } from '@angular/core';
import { AssignedContact } from '../../contacts/shared/models/Contact';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { DetailsService } from '../../details/details.service';
import * as moment from 'moment';
import { DATETIME_FORMATS } from '../utils/timeUtils';
import { EventDetail, CallDetail } from '../../contacts/shared/models/Contact';
import { getCallMode } from '../utils/call-type-mode';
import { getMsisdnlabel } from '../utils/msisdn-label';

type EventType = EventDetail | CallDetail;

@Component({
  selector: 'cc-details-view',
  templateUrl: './details-view.component.html',
  styleUrls: ['./details-view.component.scss']
})
export class DetailsViewComponent implements OnInit {
  @Input() event: EventType;
  @Input() assignedContacts: AssignedContact[];
  @Input() recordUrl: string;
  public spinnerVisible: boolean;
  public getCallingMode = getCallMode;
  public getPhoneNumberLabel = getMsisdnlabel;
  constructor(public detailsService: DetailsService) {}

  ngOnInit() {}

  getCallLength(event) {
    const callLength = event.callLength ? event.callLength : event.lengthSeconds;
    const minutes = Math.floor(callLength / 60);
    const seconds = callLength - minutes * 60;
    return minutes + seconds > 0 ? { minutes: minutes, seconds: seconds } : null;
  }

  createVoicemailFilename(event) {
    return this.detailsService.createVoicemailFilename(event);
  }

  getIsoCountry(number?: string): string {
    const generalNumber = number && parsePhoneNumberFromString(number.toString());

    return generalNumber ? generalNumber.country : '';
  }

  getUserName(event) {
    const name = event.agentName || event.name;
    const surname = event.agentSurname || event.surname;
    return `${name} ${surname}`;
  }

  getMsisdn(event) {
    return event.callerIdInfo && event.callerIdInfo.msisdn
      ? event.callerIdInfo.msisdn
      : event.agentMsisdn || event.msisdn;
  }

  getCountry(event) {
    return event.callerIdInfo && event.callerIdInfo.isoCountry
      ? event.callerIdInfo.isoCountry.toLowerCase()
      : this.getIsoCountry(event.agentMsisdn).toLowerCase() || this.getIsoCountry(event.msisdn).toLowerCase();
  }

  isRecordingAvailable(event) {
    return event.recordingAvailable || event.recordingExists;
  }

  getStatus(event) {
    return event.direction ? event.direction : event.type;
  }

  getDate(event) {
    return moment(event.createdAt ? event.createdAt : event.startDate).format(DATETIME_FORMATS.us);
  }

  getEventType(event) {
    return event.type;
  }

  isInboundAnswered(direction: string, answered: boolean) {
    return direction === 'INBOUND' && !answered;
  }
}
